import { createGlobalStyle } from 'styled-components';
export const DatePickerStyles = createGlobalStyle `
  .react-datepicker-popper:not(.adnz) {
    &[data-placement^='bottom'] .react-datepicker__triangle,
    &[data-placement^='top'] .react-datepicker__triangle,
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow {
      margin-left: -8px;
      position: absolute;
    }
    &[data-placement^='bottom'] .react-datepicker__triangle,
    &[data-placement^='top'] .react-datepicker__triangle,
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow,
    &[data-placement^='bottom']
    .react-datepicker__triangle::before,
    &[data-placement^='top']
    .react-datepicker__triangle::before,
    .react-datepicker__year-read-view--down-arrow::before,
    .react-datepicker__month-read-view--down-arrow::before,
    .react-datepicker__month-year-read-view--down-arrow::before {
      /*box-sizing: content-box;*/
      position: absolute;
      border: 8px solid transparent;
      height: 0;
      width: 1px;
    }
    &[data-placement^='bottom']
    .react-datepicker__triangle::before,
    &[data-placement^='top']
    .react-datepicker__triangle::before,
    .react-datepicker__year-read-view--down-arrow::before,
    .react-datepicker__month-read-view--down-arrow::before,
    .react-datepicker__month-year-read-view--down-arrow::before {
      content: '';
      z-index: -1;
      border-width: 8px;
      left: -8px;
      border-bottom-color: #aeaeae;
    }

    &[data-placement^='bottom'] .react-datepicker__triangle {
      top: 0;
      margin-top: -8px;
    }

    &[data-placement^='bottom'] .react-datepicker__triangle,
    &[data-placement^='bottom']
    .react-datepicker__triangle::before {
      border-top: none;
      border-bottom-color: ${({ theme }) => theme.colors.grey05_1}
    ;
    }

    &[data-placement^='bottom']
    .react-datepicker__triangle::before {
      top: -1px;
      border-bottom-color: #aeaeae;
    }

    &[data-placement^='top'] .react-datepicker__triangle,
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow {
      bottom: 0;
      margin-bottom: -8px;
    }

    &[data-placement^='top'] .react-datepicker__triangle,
    .react-datepicker__year-read-view--down-arrow,
    .react-datepicker__month-read-view--down-arrow,
    .react-datepicker__month-year-read-view--down-arrow,
    &[data-placement^='top']
    .react-datepicker__triangle::before,
    .react-datepicker__year-read-view--down-arrow::before,
    .react-datepicker__month-read-view--down-arrow::before,
    .react-datepicker__month-year-read-view--down-arrow::before {
      border-bottom: none;
      border-top-color: ${({ theme }) => theme.colors.grey00_1};
    }

    &[data-placement^='top']
    .react-datepicker__triangle::before,
    .react-datepicker__year-read-view--down-arrow::before,
    .react-datepicker__month-read-view--down-arrow::before,
    .react-datepicker__month-year-read-view--down-arrow::before {
      bottom: -1px;
      border-top-color: #aeaeae;
    }
    & {
      z-index: 7;
      border-radius: 4px;
    }

    &[data-placement^='bottom'] {
      margin-top: 10px;
    }

    &[data-placement^='top'] {
      margin-bottom: 10px;
    }

    &[data-placement^='right'] {
      margin-left: 8px;
    }

    &[data-placement^='right'] .react-datepicker__triangle {
      left: auto;
      right: 42px;
    }

    &[data-placement^='left'] {
      margin-right: 8px;
    }

    &[data-placement^='left'] .react-datepicker__triangle {
      left: 42px;
      right: auto;
    }
    .react-datepicker-wrapper {
    display: block;
    position: relative;
    width: 100%;
  }

  .react-datepicker {
    color: ${({ theme }) => theme.colors.black_1};
    position: relative;
    background-color: ${({ theme }) => theme.colors.grey00_6};
    border-radius: 4px;
    font-size: 13px;
    display: inline-flex;
    overflow: hidden;
    ${({ theme: { shadows } }) => shadows.large};
  }

  .react-datepicker--time-only .react-datepicker__triangle {
    left: 35px;
  }

  .react-datepicker--time-only .react-datepicker__time-container {
    border-left: 0;
  }

  .react-datepicker--time-only .react-datepicker__time {
    height: auto;
  }

  .react-datepicker__triangle {
    position: absolute;
    left: 50px;
  }

  .react-datepicker__header {
    text-align: center;
    position: relative;
    border: none;
    border-radius: 0;
    padding: 0;
  }

  .react-datepicker__header--time {
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-color: ${({ theme }) => theme.colors.grey30_1};
    position: relative;
    z-index: 1;
  }

  .react-datepicker__year-dropdown-container--select,
  .react-datepicker__month-dropdown-container--select,
  .react-datepicker__month-year-dropdown-container--select,
  .react-datepicker__year-dropdown-container--scroll,
  .react-datepicker__month-dropdown-container--scroll,
  .react-datepicker__month-year-dropdown-container--scroll {
    display: inline-block;
    margin: 0 2px;
  }

  .react-datepicker__current-month,
  .react-datepicker-time__header {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
    color: ${({ theme }) => theme.colors.black_1};
    font-weight: 500;
    font-size: 14px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
    height: 52px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .react-datepicker-time__header {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  .react-datepicker__navigation {
    align-items: center;
    background: none;
    display: flex;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    position: absolute;
    top: 14px;
    padding: 0;
    border: none;
    z-index: 1;
    height: 24px;
    width: 24px;
    text-indent: -999em;
    overflow: hidden;
  }

  .react-datepicker__navigation-icon {
    position: relative;
    top: -1px;
    font-size: 20px;
    width: 0;
  }
  .react-datepicker__navigation-icon:before, .react-datepicker__year-read-view--down-arrow, .react-datepicker__month-read-view--down-arrow, .react-datepicker__month-year-read-view--down-arrow {
    border-color: ${({ theme }) => theme.colors.black_1};
    border-style: solid;
    border-width: 2px 2px 0 0;
    content: "";
    display: block;
    height: 8px;
    position: absolute;
    top: 7px;
    width: 8px;
  }

  .react-datepicker__portal .react-datepicker__navigation--next {
    right: 14px;
  }
    

  .react-datepicker__navigation--previous {
    left: 14px;
    transform: rotateY(180deg);
  }
  .react-datepicker__navigation-icon--previous {
    &:before {
      transform: rotate(45deg);
      right: -4px;
    }
  }

  .react-datepicker__navigation--next {
    right: 14px;
  }
  .react-datepicker__navigation-icon--next {
    &:before {
      transform: rotate(45deg);
      left: -7px;
    }
  }

  .react-datepicker__navigation--previous--disabled,
  .react-datepicker__navigation--previous--disabled:hover,
  .react-datepicker__navigation--next--disabled,
  .react-datepicker__navigation--next--disabled:hover {
    opacity: .4;
    cursor: default;
  }

  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {
    right: 90px;
  }

  .react-datepicker__navigation--next:hover {
    border-left-color: #b3b3b3;
  }

  .react-datepicker__navigation--next--disabled,
  .react-datepicker__navigation--next--disabled:hover {
    border-left-color: #e6e6e6;
    cursor: default;
  }

  .react-datepicker__navigation--years {
    position: relative;
    top: 0;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .react-datepicker__navigation--years-previous {
    top: 4px;
    border-top-color: ${({ theme }) => theme.colors.grey30_1};
  }

  .react-datepicker__navigation--years-previous:hover {
    border-top-color: #b3b3b3;
  }

  .react-datepicker__navigation--years-upcoming {
    top: -4px;
    border-bottom-color: ${({ theme }) => theme.colors.grey30_1};
  }

  .react-datepicker__navigation--years-upcoming:hover {
    border-bottom-color: #b3b3b3;
  }

  .react-datepicker__month-container {
    float: left;
  }

  .react-datepicker__month-container + .react-datepicker__month-container .react-datepicker__month,
  .react-datepicker__month-container + .react-datepicker__month-container .react-datepicker__day-names {
    border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
  }

  .react-datepicker__month {
    text-align: center;
    border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
    margin: 0 0 3px;
  }

  .react-datepicker__time-container {
    width: auto;
    display: flex;
    flex-direction: column;
    border-left: 1px solid ${({ theme }) => theme.colors.grey10_1};
    overflow: hidden;
    z-index: 1;
  }

  .react-datepicker__time-container--with-today-button {
    display: inline;
    border: 1px solid #aeaeae;
    border-radius: 0.3rem;
    position: absolute;
    right: -72px;
    top: 0;
  }

  .react-datepicker:not(.react-datepicker--time-only) .react-datepicker__time {
    height: 220px;
  }

  .react-datepicker--time-only .react-datepicker__time {
    height: 160px;
  }
  .react-datepicker--time-only .react-datepicker__time-box,
  .react-datepicker--time-only .react-datepicker__time-list {
    height: 100%;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box {
    width: 76px;
    margin: 0 auto;
    text-align: center;
    overflow: hidden;
    padding: 0;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list {
    list-style: none;
    overflow-y: scroll;
    box-sizing: content-box;
    margin: 0 -17px -17px 0;
    padding: 0 17px 17px 0;
    height: 160px;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item {
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 1;
    outline: none;
  }

  li.react-datepicker__time-list-item {
    border-radius: 4px;
    margin: 3px;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.grey05_1}
;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected {
    color: white;
    background: ${({ theme }) => theme.colors.main};
    font-weight: normal;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--selected:hover {
    background: ${({ theme }) => theme.colors.main};
    font-weight: normal;
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--disabled {
    color: ${({ theme }) => theme.colors.grey30_1};
  }

  .react-datepicker__time-container
  .react-datepicker__time
  .react-datepicker__time-box
  ul.react-datepicker__time-list
  li.react-datepicker__time-list-item--disabled:hover {
    cursor: default;
    background-color: transparent;
  }

  .react-datepicker__week-number {
    width: 34px;
    height: 32px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    color: ${({ theme }) => theme.colors.grey100_1};
    font-weight: 500;
    opacity: .7;
    margin: 2px 3px;
  }

  .react-datepicker__week-number.react-datepicker__week-number--clickable {
    cursor: pointer;
  }

  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {
    border-radius: 0.3rem;
    background-color: ${({ theme }) => theme.colors.grey05_1}
;
  }

  .react-datepicker__day-names,
  .react-datepicker__week {
    white-space: nowrap;
  }

  .react-datepicker__day-names {
    background: ${({ theme }) => theme.colors.grey01_1};
  }

  .react-datepicker__day-name,
  .react-datepicker__day,
  .react-datepicker__time-name {
    display: inline-flex;
    width: 34px;
    height: 32px;
    justify-content: center;
    align-items: center;
    margin: 2px;
    outline: none;
  }

  .react-datepicker__day-name {
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.grey100_1};
  }

  .react-datepicker__day {
    cursor: pointer;
    &:not(.react-datepicker__day--in-range):not(.react-datepicker__day--in-selecting-range):not(.react-datepicker__day--disabled) {
      border-radius: 4px;
    }
  }

  .react-datepicker__day:hover {
    background: ${({ theme }) => theme.colors.grey05_1};
  }

  .react-datepicker__day--outside-month:not(.react-datepicker__day--selected) {
    color: ${({ theme }) => theme.colors.grey100_1};
    opacity: .4;
  }

  .react-datepicker__day--outside-month.react-datepicker__day--selected {
    color: ${({ theme }) => theme.colors.grey00_1};
  }

  .react-datepicker__day--today {
    font-weight: 500;
  }

  .react-datepicker__day--highlighted {
    border-radius: 0.3rem;
    background-color: #3dcc4a;
    color: ${({ theme }) => theme.colors.grey00_1};
  }

  .react-datepicker__day--highlighted:hover {
    background-color: #32be3f;
  }

  .react-datepicker__day--highlighted-custom-1 {
    color: magenta;
  }

  .react-datepicker__day--highlighted-custom-2 {
    color: green;
  }

  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.grey00_2};
  }

  .react-datepicker__day--keyboard-selected {
    background-color: ${({ theme }) => theme.colors.main};
    color: ${({ theme }) => theme.colors.grey00_2};
  }

  .react-datepicker__day--selected:hover,
  .react-datepicker__day--in-selecting-range:hover,
  .react-datepicker__day--in-range:hover,
  .react-datepicker__day--keyboard-selected:hover {
    background-color: ${({ theme }) => theme.colors.main};
  }

  .react-datepicker__month--selecting-range
  .react-datepicker__day--in-range:not(.react-datepicker__day--in-selecting-range) {
    background-color: ${({ theme }) => theme.colors.grey05_1};
    color: ${({ theme }) => theme.colors.black_1};
  }

  .react-datepicker__day--disabled {
    cursor: default;
    color: ${({ theme }) => theme.colors.grey100_1};
    opacity: .1;
  }

  .react-datepicker__day--disabled:hover {
    background-color: transparent;
  }

  .react-datepicker__input-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .react-datepicker__year-read-view,
  .react-datepicker__month-read-view,
  .react-datepicker__month-year-read-view {
    border: 1px solid transparent;
    border-radius: 0.3rem;
  }

  .react-datepicker__year-read-view:hover,
  .react-datepicker__month-read-view:hover,
  .react-datepicker__month-year-read-view:hover {
    cursor: pointer;
  }

  .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {
    border-top-color: #b3b3b3;
  }

  .react-datepicker__year-read-view--down-arrow,
  .react-datepicker__month-read-view--down-arrow,
  .react-datepicker__month-year-read-view--down-arrow {
    border-top-color: ${({ theme }) => theme.colors.grey30_1};
    float: right;
    margin-left: 20px;
    top: 8px;
    position: relative;
    border-width: 0.45rem;
  }

  .react-datepicker__year-dropdown,
  .react-datepicker__month-dropdown,
  .react-datepicker__month-year-dropdown {
    background-color: ${({ theme }) => theme.colors.grey05_1}
;
    position: absolute;
    width: 50%;
    left: 25%;
    top: 30px;
    z-index: 1;
    text-align: center;
    border-radius: 0.3rem;
    border: 1px solid #aeaeae;
  }

  .react-datepicker__year-dropdown:hover,
  .react-datepicker__month-dropdown:hover,
  .react-datepicker__month-year-dropdown:hover {
    cursor: pointer;
  }

  .react-datepicker__year-dropdown--scrollable,
  .react-datepicker__month-dropdown--scrollable,
  .react-datepicker__month-year-dropdown--scrollable {
    height: 150px;
    overflow-y: scroll;
  }

  .react-datepicker__year-option,
  .react-datepicker__month-option,
  .react-datepicker__month-year-option {
    line-height: 20px;
    width: 100%;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }

  .react-datepicker__year-option:first-of-type,
  .react-datepicker__month-option:first-of-type,
  .react-datepicker__month-year-option:first-of-type {
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .react-datepicker__year-option:last-of-type,
  .react-datepicker__month-option:last-of-type,
  .react-datepicker__month-year-option:last-of-type {
    user-select: none;
    border-bottom-left-radius: 0.3rem;
    border-bottom-right-radius: 0.3rem;
  }

  .react-datepicker__year-option:hover,
  .react-datepicker__month-option:hover,
  .react-datepicker__month-year-option:hover {
    background-color: ${({ theme }) => theme.colors.grey30_1};
  }

  .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {
    border-bottom-color: #b3b3b3;
  }


  .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,
  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {
    border-top-color: #b3b3b3;
  }

  .react-datepicker__year-option--selected,
  .react-datepicker__month-option--selected,
  .react-datepicker__month-year-option--selected {
    position: absolute;
    left: 15px;
  }

  .react-datepicker__close-icon {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    outline: 0;
    padding: 0;
    vertical-align: middle;
    position: absolute;
    height: 16px;
    width: 16px;
    top: 25%;
    right: 7px;
  }

  .react-datepicker__close-icon::after {
    background-color: #216ba5;
    border-radius: 50%;
    bottom: 0;
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.grey00_1};
    content: '\\00d7';
    cursor: pointer;
    font-size: 12px;
    height: 16px;
    width: 16px;
    line-height: 1;
    margin: -8px auto 0;
    padding: 2px;
    position: absolute;
    right: 0px;
    text-align: center;
  }

  .react-datepicker__today-button {
    background: ${({ theme }) => theme.colors.grey05_1}
;
    border-top: 1px solid #aeaeae;
    cursor: pointer;
    text-align: center;
    font-weight: 500;
    padding: 5px 0;
    clear: left;
  }

  .react-datepicker__portal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 2147483647;
  }

  .react-datepicker__portal .react-datepicker__day-name,
  .react-datepicker__portal .react-datepicker__day,
  .react-datepicker__portal .react-datepicker__time-name {
    width: 3rem;
    line-height: 3rem;
  }

  @media (max-width: 400px), (max-height: 550px) {
    .react-datepicker__portal .react-datepicker__day-name,
    .react-datepicker__portal .react-datepicker__day,
    .react-datepicker__portal .react-datepicker__time-name {
      width: 2rem;
      line-height: 2rem;
    }
  }

  .react-datepicker__portal .react-datepicker__current-month,
  .react-datepicker__portal .react-datepicker-time__header {
    font-size: 1.44rem;
  }
  .react-datepicker__aria-live {
    display: none;
  }
  }
`;
